import AppConstant from '../../../../../config/app.constants';
import BaseController from '../common/environment_config.base.controller'

class EnvironmentConfigEditController extends BaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, EnvironmentConfigService, Modal, $translate, $q, $stateParams) {

        super(Auth, $state, User, EnvironmentConfigService, Modal, $translate)

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.Modal = Modal;
        this.$q = $q;
        this.$stateParams = $stateParams;
        this.model = {};
    }

    $onInit() {}
}

export default EnvironmentConfigEditController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/environment_config/edit/environment_config.edit.controller.js